import { render, staticRenderFns } from "./MeetingRecording.vue?vue&type=template&id=8fd6f056"
import script from "./MeetingRecording.vue?vue&type=script&lang=js"
export * from "./MeetingRecording.vue?vue&type=script&lang=js"
import style0 from "./MeetingRecording.vue?vue&type=style&index=0&id=8fd6f056&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports